import './App.css';
import React from 'react';
import GUI from './GUI/GUI';
import ReactDOM from 'react-dom';

function App() {
  return (
    <div className="App">
      <GUI></GUI>
    </div>
  );
}

export default App;

